// extracted by mini-css-extract-plugin
module.exports = {"container":"KcWelcomeLayerPrompt_container__2Cfuo","button":"KcWelcomeLayerPrompt_button__2zROY"};